// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/admedia/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/admedia/parallax.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.admedia-banner1 .layer1{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.admedia-banner1 .layer3{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 100%;
    right: 0;
    bottom: 0;
}
.admedia-banner1 .layer2{
    align-items: center;
}
.admedia-banner1 .layer2 .text-container{
    top: 0;
    margin-bottom: 0;
}
.admedia-banner1 .layer2 .text-container p{
    width: 80%;
}


.admedia-section-2{
    height: fit-content;
    width: 100%;
    background: #FAEC24;
    display: flex;

}
.ad-media-banner-container .banner h1 span{
    color: #FAEC24;
}

.admedia-section-2 h1{
    color: #000;
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 53px;
}
.admedia-section-2 img{
    width:44%;
}
.admedia-section-2 .sec-title{
    width: 50%;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    padding-left: 6%;
}
/* .admedia-section-2 .sec-title h1{
    width: 75%;
} */

.admedia-section-2 .sec-title .blackline{
    height: 4px;
    width: 130px;
    background-color: rgb(0, 0, 0);
    position: relative;
    top: 2rem;
}


.admedia-section-3{
    height: fit-content;
    width: 100%;
    background: #000000;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 80px;
    padding-bottom: 60px;

}
.admedia-section-3 .sec-content{
    width: 75%;
}
.admedia-section-3 .sec-content p{
    line-height: 27px;
    padding-bottom: 2rem;
    text-align: left;
}

.admedia-section-4{
    width: 100%;
    height: fit-content;
    background-color: #000000;
    display: flex;
    justify-content: space-between; /* Adjust as needed */
    align-items: center;
    padding-bottom: 4rem;
}
.admedia-section-4 .image-container {
    width: 100%;
    height: auto;
}
.admedia-section-4 .image-container {
    position: relative;
    width: 100%; /* Adjust as needed */
}
.admedia-section-4 img {
    width: 100%;
    height: auto;
}

.admedia-section-4 .image-container .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    transition: opacity 0.5s ease;
}

.image-container:hover .overlay {
    opacity: 1;
}

.image-container:hover .overlay {
    opacity: 1;
}

.admedia-section-4 .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    font-size: 32px;
    font-weight: 700;
    z-index: 1;
}

.admedia-section-4 .line {
    position: absolute;
    top: 60%;
    left: 45%;
    transform: translateX(-50%, 50%);
    width: 0;
    height: 1px;
    background-color: white;
    transition: width 0.5s ease;
    transform-origin:  left;
}

.admedia-section-4 .image-container:hover .line {
    width: 50px;
}





@media (min-width:768px) and (max-width:992px) {
    .admedia-banner1 .layer3{
        right: 0;
    }
    .admedia-banner1 .layer2 .text-container p {
        width: 90%;
    }
    .admedia-section-2{
        flex-direction: column;
    }
    .admedia-section-2 img{
        width: 100%;
        height: 80%;
    }
    .ad-media-banner-container .banner h1{
        margin-bottom: 2rem;
    }
    
    .admedia-section-2 .sec-title{
        width: 100%;
        height: 450px;
        position: relative;
        bottom: 1rem;
        padding-left: 12%;
    }
    .admedia-section-4 .image-container{
        max-width: 35%;
    }
    .admedia-section-4 .title{
        font-size: 22px;
    }
    .admedia-section-4 .line{
        left: 41%;
    }
}

@media (max-width:576px){
    /* .admedia-banner1 .layer3{
        background-image: url(../../public/images/blog/parallax-sm.png);
    } */
    .admedia-banner1 .layer3{
        right: 0;
        left: 0;
        height: 60%;
    }
    .admedia-banner1 .layer2 .text-container p {
        width: 100%;
    }

    .admedia-section-2 img{
        width: 100%;
    }
    .admedia-section-2 h1 {
        font-size: 34px;
        line-height: 40px;
        
    }
    .admedia-section-2 .sec-title .blackline{
        width: 60px;
        top: 1rem;
    }
    .admedia-section-4{
        flex-direction: column;
    }
    .admedia-section-4 .line {
        margin-left: auto;
    }
    .admedia-section-2{
        flex-direction: column;
    }
    .admedia-section-2 .sec-title {
        width: 50%;
        height: 299px;
    }
    .admedia-section-3 .sec-content {
        width: 86%;
    }
}

@media (min-width:1400px){
    .admedia-section-3 .sec-content{
        width: 70%;
    }
    .admedia-section-4 .title {
        max-width: 200px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Admedia.css"],"names":[],"mappings":";;AAEA;IACI,yDAA6D;AACjE;AACA;IACI,yDAA+D;IAC/D,YAAY;IACZ,QAAQ;IACR,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,MAAM;IACN,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;;;AAGA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;;AAEjB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,SAAS;AACb;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;;GAEG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;AACb;;;AAGA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;;AAExB;AACA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,8BAA8B,EAAE,qBAAqB;IACrD,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW,EAAE,qBAAqB;AACtC;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;;;;;AAMA;IACI;QACI,QAAQ;IACZ;IACA;QACI,UAAU;IACd;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;;OAEG;IACH;QACI,QAAQ;QACR,OAAO;QACP,WAAW;IACf;IACA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,iBAAiB;;IAErB;IACA;QACI,WAAW;QACX,SAAS;IACb;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,aAAa;IACjB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["\r\n\r\n.admedia-banner1 .layer1{\r\n    background-image: url(../../public/images/admedia/banner.png);\r\n}\r\n.admedia-banner1 .layer3{\r\n    background-image: url(../../public/images/admedia/parallax.png);\r\n    height: 100%;\r\n    right: 0;\r\n    bottom: 0;\r\n}\r\n.admedia-banner1 .layer2{\r\n    align-items: center;\r\n}\r\n.admedia-banner1 .layer2 .text-container{\r\n    top: 0;\r\n    margin-bottom: 0;\r\n}\r\n.admedia-banner1 .layer2 .text-container p{\r\n    width: 80%;\r\n}\r\n\r\n\r\n.admedia-section-2{\r\n    height: fit-content;\r\n    width: 100%;\r\n    background: #FAEC24;\r\n    display: flex;\r\n\r\n}\r\n.ad-media-banner-container .banner h1 span{\r\n    color: #FAEC24;\r\n}\r\n\r\n.admedia-section-2 h1{\r\n    color: #000;\r\n    font-family: 'Poppins';\r\n    font-weight: 700;\r\n    font-size: 53px;\r\n}\r\n.admedia-section-2 img{\r\n    width:44%;\r\n}\r\n.admedia-section-2 .sec-title{\r\n    width: 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* align-items: center; */\r\n    justify-content: center;\r\n    padding-left: 6%;\r\n}\r\n/* .admedia-section-2 .sec-title h1{\r\n    width: 75%;\r\n} */\r\n\r\n.admedia-section-2 .sec-title .blackline{\r\n    height: 4px;\r\n    width: 130px;\r\n    background-color: rgb(0, 0, 0);\r\n    position: relative;\r\n    top: 2rem;\r\n}\r\n\r\n\r\n.admedia-section-3{\r\n    height: fit-content;\r\n    width: 100%;\r\n    background: #000000;\r\n    color: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding-top: 80px;\r\n    padding-bottom: 60px;\r\n\r\n}\r\n.admedia-section-3 .sec-content{\r\n    width: 75%;\r\n}\r\n.admedia-section-3 .sec-content p{\r\n    line-height: 27px;\r\n    padding-bottom: 2rem;\r\n    text-align: left;\r\n}\r\n\r\n.admedia-section-4{\r\n    width: 100%;\r\n    height: fit-content;\r\n    background-color: #000000;\r\n    display: flex;\r\n    justify-content: space-between; /* Adjust as needed */\r\n    align-items: center;\r\n    padding-bottom: 4rem;\r\n}\r\n.admedia-section-4 .image-container {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n.admedia-section-4 .image-container {\r\n    position: relative;\r\n    width: 100%; /* Adjust as needed */\r\n}\r\n.admedia-section-4 img {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.admedia-section-4 .image-container .overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.7);\r\n    opacity: 0;\r\n    transition: opacity 0.5s ease;\r\n}\r\n\r\n.image-container:hover .overlay {\r\n    opacity: 1;\r\n}\r\n\r\n.image-container:hover .overlay {\r\n    opacity: 1;\r\n}\r\n\r\n.admedia-section-4 .title {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    text-align: center;\r\n    color: white;\r\n    font-size: 32px;\r\n    font-weight: 700;\r\n    z-index: 1;\r\n}\r\n\r\n.admedia-section-4 .line {\r\n    position: absolute;\r\n    top: 60%;\r\n    left: 45%;\r\n    transform: translateX(-50%, 50%);\r\n    width: 0;\r\n    height: 1px;\r\n    background-color: white;\r\n    transition: width 0.5s ease;\r\n    transform-origin:  left;\r\n}\r\n\r\n.admedia-section-4 .image-container:hover .line {\r\n    width: 50px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n@media (min-width:768px) and (max-width:992px) {\r\n    .admedia-banner1 .layer3{\r\n        right: 0;\r\n    }\r\n    .admedia-banner1 .layer2 .text-container p {\r\n        width: 90%;\r\n    }\r\n    .admedia-section-2{\r\n        flex-direction: column;\r\n    }\r\n    .admedia-section-2 img{\r\n        width: 100%;\r\n        height: 80%;\r\n    }\r\n    .ad-media-banner-container .banner h1{\r\n        margin-bottom: 2rem;\r\n    }\r\n    \r\n    .admedia-section-2 .sec-title{\r\n        width: 100%;\r\n        height: 450px;\r\n        position: relative;\r\n        bottom: 1rem;\r\n        padding-left: 12%;\r\n    }\r\n    .admedia-section-4 .image-container{\r\n        max-width: 35%;\r\n    }\r\n    .admedia-section-4 .title{\r\n        font-size: 22px;\r\n    }\r\n    .admedia-section-4 .line{\r\n        left: 41%;\r\n    }\r\n}\r\n\r\n@media (max-width:576px){\r\n    /* .admedia-banner1 .layer3{\r\n        background-image: url(../../public/images/blog/parallax-sm.png);\r\n    } */\r\n    .admedia-banner1 .layer3{\r\n        right: 0;\r\n        left: 0;\r\n        height: 60%;\r\n    }\r\n    .admedia-banner1 .layer2 .text-container p {\r\n        width: 100%;\r\n    }\r\n\r\n    .admedia-section-2 img{\r\n        width: 100%;\r\n    }\r\n    .admedia-section-2 h1 {\r\n        font-size: 34px;\r\n        line-height: 40px;\r\n        \r\n    }\r\n    .admedia-section-2 .sec-title .blackline{\r\n        width: 60px;\r\n        top: 1rem;\r\n    }\r\n    .admedia-section-4{\r\n        flex-direction: column;\r\n    }\r\n    .admedia-section-4 .line {\r\n        margin-left: auto;\r\n    }\r\n    .admedia-section-2{\r\n        flex-direction: column;\r\n    }\r\n    .admedia-section-2 .sec-title {\r\n        width: 50%;\r\n        height: 299px;\r\n    }\r\n    .admedia-section-3 .sec-content {\r\n        width: 86%;\r\n    }\r\n}\r\n\r\n@media (min-width:1400px){\r\n    .admedia-section-3 .sec-content{\r\n        width: 70%;\r\n    }\r\n    .admedia-section-4 .title {\r\n        max-width: 200px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
